<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Common Configuration</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <!-- <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" /> -->
                </div>
            </div>
            <div class="card p-mt-4">
                <DataTable :value="commonConfigSettings" :lazy="true" :paginator="true" :rows="itemsPerPage"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    dataKey="ad1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Configuration" icon="pi pi-plus" @click="toAddCommonConfig" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Config Key Title" field="eb2" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <div>{{ data.eb2 }}</div>
                        </template>
                    </Column>
                    <!-- <Column header="Config JSON" field="eb3" headerStyle="width: 45%">
                        <template #body="{ data }">
                            <div>
                                <span v-if="!data._expanded">
                                    {{ data.eb3.length > 25 ? data.eb3.substring(0, 25) + '...' : data.eb3 }}
                                </span>
                                <span v-else>
                                    {{ data.eb3 }}
                                </span>
                                <br/> -->

                                <!-- Toggle button only if text is longer than 25 -->
                                <!-- <Button 
                                    v-if="data.eb3.length > 25" 
                                    class="p-button-link p-pl-0" 
                                    @click="data._expanded = !data._expanded" 
                                    :label="data._expanded ? 'Show Less' : 'Show More'" />
                            </div>
                        </template>
                    </Column> -->
                    <Column header="Editable" headerStyle="width: 15%">
                        <template #body="{ data }">
                             <InputSwitch 
                                :modelValue="data.eb4 == 1" 
                                @update:modelValue="val => confirmKeyEditStatus({ ...data, eb4: val ? 1 : 0 })" 
                                />
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="toEditCommonConfig(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>

    <!-- Add/Edit Common Config Setting starts here -->
    <Dialog v-model:visible="isAddOrEditCommonConfig" 
        :style="{ width: '800px' }" :modal="true" class="p-fluid"
        :header="isAddCommonConfig ? 'Add Configuration Setting' : 'Edit Configuration Setting'">
        <div style="position: relative">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label for="configKey">
                            Config Key Title
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="configKey" v-model="configKey" required="true" maxlength="70"
                            placeholder="Enter Config Key Title" :class="{ 'p-invalid': submitted && !configKey }"/>
                        <small class="p-invalid p-error" v-if="v$.configKey.$error">{{
                        v$.configKey.$errors[0].$message
                        }}</small>
                    </div>

                    <div class="p-field p-col-12 p-md-12">
                        <label for="document-type">
                            Config Json
                            <!-- <span class="p-invalid p-error">*</span> -->
                        </label>
                        <Textarea id="configJson" v-model="configJson" :autoResize="true" rows="7" cols="30"
                            placeholder="Enter Confog Json Here" maxlength="2000"/>
                    </div>
                    <div class="p-field p-col-12 p-md-6" v-if="isAddCommonConfig"> 
                        <label>Is Editable <span class="p-invalid p-error"> *</span>
                        </label> 
                        <div class="p-field-radiobutton"> 
                            <RadioButton id="is_editable" name="option" v-bind:value="1" v-model="isEditable" :checked="isEditable == 1" /> 
                            <label for="is_editable" class="p-mr-2">Yes</label> 
                            <RadioButton id="is_not_editable" name="option" v-bind:value="0" v-model="isEditable" :checked="isEditable == 0" /> 
                            <label for="is_not_editable" class="p-mr-2">No</label> 
                        </div> 
                    </div>
                    <div class="p-field p-col-12 p-md-6" v-if="!isAddCommonConfig">
                        <label>Status</label>
                        <Dropdown id="statusType" v-model="statusType" :options="statusOptions" optionLabel="label"
                            optionValue="value" placeholder="Select ..." appendTo="body"></Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoader ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addOrEditCommonConfig" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add/Edit Common Config Setting ends here -->

    <!-- confirmation modal start here -->
    <ConfirmDialog group="positioned" style="width: 325px;" />
    <!-- confirmation modal end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import router from '@/router';
import { required, helpers } from '@vuelidate/validators';
import { useConfirm } from "primevue/useconfirm";

export default {
    data() {
        return {
            confirm: useConfirm(),
            commonConfigSettings: [],
            v$: useValidate(),
            isAddOrEditCommonConfig: false,
            isAddCommonConfig: false,
            submitted: false,
            expandedRows: [],
            statusOptions: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 2 }
            ],
            loading: false,
            configId: '',
            configKey: '',
            configJson: '',
            statusType: 1,
            isEditable: 1,
            page_no: 0,
            itemsPerPage: 30,
            totalRecords: 0,
            showLoader: false,
            localAdminName: '',
        };
    },
    validations() {
        return {
            configKey: { required: helpers.withMessage('Please enter config key', required) },
            // configJson: { required: helpers.withMessage('Please enter config json', required) },
            isEditable: { required: helpers.withMessage('Please select file is editable or not', required) },
            statusType: { required: helpers.withMessage('Please select active status', required) },
        };
    },
    ApiService: null,
    interval: null,
    computed: {
        callStatusFlag() {
            return this.$store.getters.getCallStatusFlag;
        }
    },
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.loading = true;
        this.getCommonConfigSettings({ clientId: this.routeParam, page_no: this.page_no, itemsPerPage: this.itemsPerPage });
    },
    methods: {
        async toAddCommonConfig() {
            this.isAddOrEditCommonConfig = true;
            this.isAddCommonConfig = true;
            this.submitted = false;
            this.configId = '';
            this.configKey = '';
            this.configJson = '';
            this.isEditable = 1;
            this.statusType = 1;
            this.v$.$reset();
        },
        toEditCommonConfig(data) {
            this.isAddOrEditCommonConfig = true;
            this.isAddCommonConfig = false;
            this.submitted = false;
            this.configId = data.eb1;
            this.configKey = data.eb2;
            this.configJson = data.eb3;
            this.isEditable = data.eb4;
            this.statusType = data.eb5;
            this.v$.$reset();
        },
        addOrEditCommonConfig() {
            this.errormsg = '';
            let fields = {};
            this.submitted = true;
            fields['clientId'] = this.routeParam;
            fields['eb1'] = this.configId;
            fields['eb2'] = this.configKey;
            fields['eb3'] = this.configJson;
            fields['eb4'] = this.isEditable;
            fields['eb5'] = this.statusType;
            this.v$.$validate();

            // console.log("Validation errors:", this.v$.$errors);
            if (!this.v$.$error) {
                this.showLoader = true;
                this.ApiService.insertUpdateCommonConfig(fields).then((items) => {
                    if (items.status == 200) {
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getCommonConfigSettings({ clientId: this.routeParam, page_no: this.page_no, itemsPerPage: this.itemsPerPage });
                        this.isAddOrEditCommonConfig = false;
                        this.isisAddCommonConfig = false;
                        this.submitted = false;
                        this.configKey = '';
                        this.configJson = '';
                        this.isEditable = 1;
                        this.statusType = 1;
                    } else {
                        this.showLoader = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        changeRowEditStatus(data) {
            let formData = new FormData();
            formData.append('clientId', this.routeParam);
            formData.append('eb1', data.eb1);
            formData.append('eb4', data.eb4 == 1 ? 1 : 0);
            this.errormsg = '';
            this.showLoader = true;
            this.ApiService.updateConfigKeyEditStatus(formData)
                .then((response) => {
                    this.showLoader = false;
                    if (response.status == 200) {
                        var successMsg = response.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getCommonConfigSettings({ clientId: this.routeParam, page_no: this.page_no, itemsPerPage: this.itemsPerPage });
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                    }
                })
                .catch(error => {
                    this.showLoader = false;
                    console.error("API Error:", error);
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong!', life: 3000 });
                });

        },
        confirmKeyEditStatus(data) {
            this.$confirm.require({
                group: 'positioned',
                message: 'Are you sure?',
                header: 'Confirm edit status change',
                icon: 'pi pi-exclamation-triangle',
                position: 'center',
                rejectProps: {
                    label: 'Cancel',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Confirm',
                    severity: 'danger'
                },
                accept: () => {
                    this.changeRowEditStatus(data);
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Cancelled', detail: 'Change edit status cancelled', life: 3000 });
                    data.eb4 = data.eb4 == 1 ? 0 : 1;
                },
            });
        },
        async getCommonConfigSettings(payload) {
            try {
                const result = await this.ApiService.getCommonConfigSettings(payload);
                this.commonConfigSettings = result.data;
                this.totalRecords = result.count;
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            } finally {
                this.loading = false;
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getCommonConfigSettings({ clientId: this.routeParam, page_no: this.page_no, itemsPerPage: this.itemsPerPage });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: this.callStatusFlag == 1 ? "callcenter" : "AppVersionSetting",
                params: { adminSubId: this.routeParam },
            });
        }
    }

};
</script>

<style scoped></style>